import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export default function SlaPage() {
  const { data = [] } = useQuery({ queryKey: ['sla'], queryFn: async () => (await api.get('/sla')).data });
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-1">SLA Policies</h1>
      <p className="text-sm text-slate-500 mb-6">First-reply and resolve targets, with per-priority overrides.</p>
      <div className="grid grid-cols-2 gap-4">
        {(data as { id: string; name: string; isDefault: boolean; isActive: boolean; firstReplyMins: number; resolveMins: number; description?: string | null }[]).map((p) => (
          <div key={p.id} className="card p-5">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-semibold text-slate-900">{p.name}</div>
                <div className="text-xs text-slate-500">{p.description ?? ''}</div>
              </div>
              <div className="flex gap-1">
                {p.isDefault && <span className="badge bg-brand-100 text-brand-700">default</span>}
                {!p.isActive && <span className="badge bg-rose-100 text-rose-700">inactive</span>}
              </div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-3 text-sm">
              <div><div className="text-xs text-slate-500">First reply</div><div className="font-medium">{p.firstReplyMins}m</div></div>
              <div><div className="text-xs text-slate-500">Resolve</div><div className="font-medium">{Math.round(p.resolveMins / 60)}h</div></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
